import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PrintIcon from '@material-ui/icons/Print';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { isMobile } from 'helpers/detect-mobile';
import { withStyles } from '@material-ui/core/styles';
import {noop} from 'lodash';
import { injectIntl } from 'components';
import { setPrintContent } from 'redux/ui/actions';


const styles = theme => ({
  dialog: {
    maxWidth: 'none',
    width: '100%',
  },
  dialogPaper: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      margin: '48px 0px 48px 0px !important',
    },
  },
  closeButton: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display : 'inline-block',
      position: 'absolute',
      top: 0,
      right: 0,
    },
   
  }
});

class PrintPreviewDialog extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    setPrintContent: PropTypes.func.isRequired,
    closeButtonOnTop : PropTypes.bool,
    type: PropTypes.string,
    currentSize: PropTypes.string,
    handlePrintSizeChange:PropTypes.func,
  };

  static defaultProps = {
    open: false,
    closeButtonOnTop: true,
    currentSize: 'normal',
    handlePrintSizeChange: noop,
  };

  state = {
    printSize: 'normal',
  }

  componentWillMount() {
    const { children, setPrintContent } = this.props;
    setPrintContent(children);
  }

  componentWillReceiveProps({ children, setPrintContent }) {
    if (children !== this.props.children) {
      setPrintContent(children);
    }
  }

  handleChange = (event) => {
    const { handlePrintSizeChange } = this.props;
    handlePrintSizeChange(event.target.value);
    this.setState({ printSize: event.target.value });

  }

  render() {
    const {
      children,
      onClose,
      open,
      title,
      closeButtonOnTop,
      classes,
      currentSize,
      type,
    } = this.props;

    return (
      <Dialog
        classes={{
          paper: classes.dialogPaper,
          root: classes.dialog,
        }}
        fullWidth={!isMobile}
        maxWidth="lg"
        onClose={onClose}
        open={open}
        scroll="body"
      >
        <DialogTitle>
          <div className="print-preview-title">
          { (type === 'FILTER_LABELS') ? (
            <Fragment>
              <div style={{width:'100%'}}>{title}</div>
              <div style={{fontSize:'15px', marginBottom: '6px', marginRight: '15px'}}>Size: </div>
              <RadioGroup row style={{width:'300px'}} aria-label="gender" name="gender1" value={currentSize} onChange={this.handleChange}>
                <FormControlLabel value="normal" control={<Radio color="primary" />} label="normal" />
                <FormControlLabel value="4x6" control={<Radio color="primary" />} label="4x6" />
              </RadioGroup>
            </Fragment>
          ) : (
            <div>{title}</div>  
          )}
           
            <IconButton
              className="print-button"
              onClick={() => window.print()}
            >
              <PrintIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent className="print-preview">
          {children}
        </DialogContent>
        {closeButtonOnTop && (
          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Dialog>
    );
  }
}

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  setPrintContent: node => dispatch(setPrintContent(node)),
});

const wrappedPrintPreviewDialog = connect(undefined, mapDispatchToProps)(
  withStyles(styles)(injectIntl(PrintPreviewDialog)),
);
wrappedPrintPreviewDialog.displayName = 'PrintPreviewDialog';

export default wrappedPrintPreviewDialog;
